const enc = encodeURIComponent;
/** The platform's side: the market's campaigns with their co-investment and spend (`incentive_lever:view`), and the kill switch (`incentive_lever:manage`). */
export class SmartCampaignsAdminApi {
    client;
    constructor(client) {
        this.client = client;
    }
    list(marketId) {
        return this.client.request({ method: 'GET', path: `/v1/admin/smart-campaigns?${new URLSearchParams({ market: marketId }).toString()}`, auth: true });
    }
    /** END a campaign now (one operator is enough); orders already promised keep their discount. */
    end(campaignId, input) {
        return this.client.request({ method: 'POST', path: `/v1/admin/smart-campaigns/${enc(campaignId)}/end`, body: input, auth: true });
    }
}
/** The merchant's side (`promotion:view` / `promotion:publish`; approval is `promotion:approve` and never the author). */
export class MerchantSmartCampaignsApi {
    client;
    constructor(client) {
        this.client = client;
    }
    list(merchantId, marketId) {
        return this.client.request({ method: 'GET', path: `/v1/merchant-smart-campaigns?${new URLSearchParams({ merchantId, marketId }).toString()}`, auth: true });
    }
    /** Declare a daily budget and a window; the system picks the mechanic. `409 MERCHANT_CAMPAIGN_POLICY_UNSET` / `MERCHANT_CAMPAIGN_FUND_POLICY_UNSET` without the policies. */
    propose(input) {
        return this.client.request({ method: 'POST', path: '/v1/merchant-smart-campaigns', body: input, auth: true });
    }
    /** A DIFFERENT identity approves or refuses; `403 MERCHANT_CAMPAIGN_SELF_APPROVAL` for the author. An approval reserves the cap before the campaign is live. */
    decide(campaignId, input) {
        return this.client.request({ method: 'POST', path: `/v1/merchant-smart-campaigns/${enc(campaignId)}/approve`, body: input, auth: true });
    }
    pause(campaignId, marketId) {
        return this.client.request({ method: 'POST', path: `/v1/merchant-smart-campaigns/${enc(campaignId)}/pause`, body: { marketId }, auth: true });
    }
    resume(campaignId, marketId) {
        return this.client.request({ method: 'POST', path: `/v1/merchant-smart-campaigns/${enc(campaignId)}/resume`, body: { marketId }, auth: true });
    }
    end(campaignId, marketId) {
        return this.client.request({ method: 'POST', path: `/v1/merchant-smart-campaigns/${enc(campaignId)}/end`, body: { marketId }, auth: true });
    }
}
//# sourceMappingURL=smart-campaigns.js.map